var _style, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileyAnnoyed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "smiley_annoyed_svg__Plus",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smiley_annoyed_svg__st1{fill:$colour-neutral-grey-900}")), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0",
  style: {
    fill: "#ffdb00"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 14.8c1-.1 2.1.1 3 .7l.7-1.1c-1.2-.7-2.5-1-3.9-.8-2.2.3-4 1.8-4.7 3.9l1.2.4c.6-1.7 2-2.9 3.7-3.1",
  className: "smiley_annoyed_svg__st1"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 9.3,
  r: 1.3,
  className: "smiley_annoyed_svg__st1"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 9.3,
  r: 1.3,
  className: "smiley_annoyed_svg__st1"
})));
export { SvgSmileyAnnoyed as ReactComponent };
export default __webpack_public_path__ + "smiley_annoyed.svg";